import { render } from "./CollectionDetailedSearchNewspapers.vue?vue&type=template&id=0aee4004&scoped=true&ts=true"
import script from "./CollectionDetailedSearchNewspapers.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchNewspapers.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchNewspapers.vue?vue&type=style&index=0&id=0aee4004&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aee4004"]])

export default __exports__